import { useState, useEffect } from 'react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useNeonFlash } from '../hooks/useNeonFlash';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SloganPopup() {
  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(true); // pause until site settings resolve
  const { t } = useLanguage();
  const flashStyle = useNeonFlash();

  const sloganKeys = ['slogan1', 'slogan2', 'slogan3', 'slogan4', 'slogan5', 'slogan6', 'slogan7', 'slogan8'];

  // Pause popups entirely when Halloween mode is engaged — jump scares handle the vibe
  useEffect(() => {
    axios.get(`${API}/api/settings/site`)
      .then(r => setPaused(!!r.data?.halloween_enabled))
      .catch(() => setPaused(false));
  }, []);

  useEffect(() => {
    if (paused) return;
    const showSlogan = () => {
      setShow(true);
      setTimeout(() => setShow(false), 3000);
      setIndex(prev => (prev + 1) % sloganKeys.length);
    };

    const initial = setTimeout(showSlogan, 10000);
    const interval = setInterval(showSlogan, 20000);

    return () => { clearTimeout(initial); clearInterval(interval); };
  }, [sloganKeys.length, paused]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          className="fixed inset-0 z-[9998] pointer-events-none flex items-center justify-center px-4"
        >
          <div className="px-6 sm:px-10 py-3 sm:py-4 rounded-full bg-black/80 border border-brand/40 backdrop-blur-md shadow-[0_0_30px_rgba(227,37,16,0.3)]">
            <p className="font-heading text-xs sm:text-xl tracking-[0.15em] sm:tracking-[0.2em] uppercase text-center font-bold" style={flashStyle}>
              {t(sloganKeys[index])}
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
